/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pending[_ngcontent-%COMP%]{color:red}.done[_ngcontent-%COMP%]{color:green}.pointer[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
